import React, { useState } from "react";
import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SwalAlert } from "../../components";

export default () => {
  const [loadingToapi, setLoadingToapi] = useState({});
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();
  const userData = useSelector((state) => state.app.userData.userData);
  const [activeTab, setActiveTab] = useState("pending");
  const [valueHiringRequests, setValueHiringRequests] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [approvedRequests, setApprovedRequests] = useState(null);
  const [popupApprovedRequests, setPopupApprovedRequests] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_BASE_URL;
  const fetchHiringRequests = async ({ queryKey }) => {
    const accessToken = localStorage.getItem("accessToken");
    const [, talentId, status, currentPage] = queryKey;
    const activestatus =
      status === "pending" ? 0 : status === "approved" ? 1 : 2;
    const { data } = await axios.get(
      `${baseURL}/api/v2/hireme/talent/${talentId}?status=${activestatus}&page=${currentPage}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return data?.data;
  };
  const {
    data: hiringRequests,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["hiringRequests", userData?.talent?.id, activeTab, currentPage],
    queryFn: fetchHiringRequests,
    enabled:
      userData?.talent?.id !== null &&
      userData?.talent?.id !== undefined &&
      (activeTab === "pending" ||
        activeTab === "approved" ||
        activeTab === "rejected"),
  });
  const { has_more_pages, total_pages } = hiringRequests || {};

  const jobUpdateMutation = useMutation({
    mutationFn: async ({ jobId, setStatus }) => {
      const accessToken = localStorage.getItem("accessToken");
      const { data } = await axios.post(
        `${baseURL}/api/v2/hireme/${jobId}`,
        setStatus,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      return data;
    },
    onSuccess: (data) => {
      setLoadingToapi(false);
      setShowPopup(false);
      const title = data.status;
      const message = data.message;
      SwalAlert(title, message, "success");
      queryClient.invalidateQueries(["hiringRequests"]);
    },
    onError: (err) => {
      setLoadingToapi(false);
      setShowPopup(false);
      SwalAlert("Oops...", err?.message, "error");
    },
  });
  const startChatMutation = useMutation({
    mutationFn: async (startChat) => {
      const accessToken = localStorage.getItem("accessToken");
      const { data } = await axios.post(
        `${baseURL}/api/chat/start`,
        startChat,
        {
          params: {
            sender_id: startChat?.sender_id,
            receiver_id: startChat?.receiver_id,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      return data;
    },
    onSuccess: (data) => {
      dispatch({
        type: "UPDATE_USER_CHAT_DATA",
        payload: { userChatData: data?.chat_head },
      });
      setLoading(false);
      navigate(`/chat/${data?.chat_head?.id}`);
    },
    onError: (err) => {
      SwalAlert("Oops...", err?.message, "error");
      setLoading(false);
    },
  });
  const handleRequestJob = (jobId, isAccepted) => {
    if (!jobId) {
      console.error("Error: jobId is undefined");
      return;
    }

    setLoadingToapi((prev) => ({ ...prev, [jobId]: isAccepted }));

    const setStatus = {
      is_hired: isAccepted,
      _method: "PUT",
    };

    jobUpdateMutation.mutate({ jobId, setStatus });
  };
  const handleStartChat = (receiver_id, sender_id, requestId) => {
    setLoading(true);
    setLoading(requestId);
    startChatMutation.mutate({ receiver_id, sender_id });
  };
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <p className="text-secondary">
          Error loading hiring requests: {error.message}
        </p>
      </div>
    );
  }
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const formatted = new Date(dateString).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
    const [day, month, year] = formatted.split(" ");
    return `${day} ${month}, ${year}`;
  };

  return {
    setActiveTab,
    activeTab,
    isLoading,
    hiringRequests,
    loadingToapi,
    handleRequestJob,
    setShowPopup,
    showPopup,
    valueHiringRequests,
    setValueHiringRequests,
    formatDate,
    approvedRequests,
    setApprovedRequests,
    popupApprovedRequests,
    setPopupApprovedRequests,
    currentPage,
    setCurrentPage,
    total_pages,
    has_more_pages,
    handleStartChat,
    loading,
  };
};
